/**
 * Fecha o aplicativo de forma compatível com cada plataforma:
 *   - Android WebView APK  → window.AndroidBridge.exitApp() (JavascriptInterface nativo)
 *   - Samsung Tizen        → tizen.application.getCurrentApplication().exit()
 *   - LG webOS / browsers  → window.close()
 */
export function closeApp(): void {
  const w = window as any;

  if (typeof w.AndroidBridge?.exitApp === 'function') {
    w.AndroidBridge.exitApp();
    return;
  }

  if (typeof w.tizen?.application?.getCurrentApplication === 'function') {
    try {
      w.tizen.application.getCurrentApplication().exit();
      return;
    } catch {
      // fallthrough
    }
  }

  window.close();
}
